// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tH54k","content":"styles_content__P9NKu","logo":"styles_logo__re8Q1","ttl":"styles_ttl__XOhyt","txt":"styles_txt__yUHqr","btn":"styles_btn__DAqxu"};